<script setup lang="ts">
import Typography from '@components/Typography.vue';
import SubmenuItem from '@layout/nav-v2/SubmenuItem.vue';
import type { Url } from '@global-types/url.ts';

defineProps<{ link: Url }>();
</script>

<template>
  <SubmenuItem
    class="group !p-2"
    :link="link"
  >
    <Typography
      variant="body"
      color="gray-darker"
      class="group-hover:text-black"
    >
      <slot />
    </Typography>
  </SubmenuItem>
</template>
